// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import Scroll from "react-scroll";
import Actions from "../../actions/Creators";
import I18n from "../../i18n/I18n";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import {
  Layout,
  Loader,
  Button,
  EmptyResults,
  SearchString,
  Pagination,
  LocaleLink
} from "../../components/common/";
import {
  CreateDisputes,
  DisputesTable,
  DisputeDetails
} from "../../components/disputes";
import Helper from "../../helper/Helper";
import ReportsEmpty from "../../components/reports/ReportsEmpty";
import styles from "../transfers/Transfers.scss";

class StockRequest extends Component {
  state = {
    limits: 40,
    page: 1,
    change: false,
    search: "",
    ticketNr: ""
  };

  componentDidMount = () => {
    if (this.props.user && this.props.seller) {
    }
    if (this.props.location && this.props.location.search) {
      this.getParams(this.props.location.search);
    }
    if (
      this.props.match.params.key !== "create" &&
      !this.props.match.params.ticketNr
    ) {
      this.listDisputes();
    }
    if (this.props.match.params.ticketNr) {
      this.setState({
        ticketNr: this.props.match.params.ticketNr,
        change: true
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.change) {
      if (this.props.match.params.key !== "create") {
        this.listDisputes();
      }
    }
    if (
      this.props.location &&
      prevProps.location &&
      this.props.location !== prevProps.location &&
      this.props.location.search
    ) {
      this.getParams(this.props.location.search);
    }
    if (this.props.match.params.ticketNr !== prevProps.match.params.ticketNr) {
      this.setState({
        ticketNr: this.props.match.params.ticketNr,
        change: true
      });
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.match !== nextProps.match ||
      this.props.seller !== nextProps.seller
    ) {
    }
  };

  listDisputes = () => {
    const { page, limits, search, ticketNr } = this.state;

    let query = `limits=${limits}&page=${page}`;
    query = search ? `${query}&search=${search}` : query;
    query = ticketNr ? `${query}&ticket_nr=${ticketNr}` : query;

    this.props.dispatch(Actions.listDisputes(query));

    this.setState({
      change: false
    });
  };

  createDispute = payload => {
    if (payload) {
      this.props.dispatch(Actions.createDispute(payload));
    }
  };

  searchDisputeAsnRtv = disputeType => {
    if (disputeType) {
      let query = disputeType ? `?dispute_type=${disputeType}` : "";
      this.props.dispatch(Actions.searchDisputeAsnRtv(query));
    }
  };

  listDisputeReasons = documentType => {
    if (documentType) {
      let query = `?document_type=${documentType}`;
      this.props.dispatch(Actions.listDisputeReasons(query));
    }
  };

  perPage = e => {
    const newState = {};
    newState.limits = e;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  onPageChange = page => {
    const newState = {};
    newState.page = page.selected + 1;
    newState.selectedItems = [];
    newState.change = true;
    this.setState(newState);
  };

  onSearch = search => {
    const newState = {};
    newState.page = 1;
    newState.search = search;
    newState.change = true;
    newState.selectedItems = [];
    this.setState(newState);
  };

  clearSearch = () => {
    const newState = {};
    newState.search = "";
    newState.change = true;
    newState.selectedItems = [];
    this.setState(newState);
  };

  getParams = searchString => {
    const params = URLSearchParams ? new URLSearchParams(searchString) : "";
    const itemNr = params && params.get("item_nr");
    const from = params && params.get("from");
    const to = params && params.get("to");
    const newState = {};
    let haveParam = false;
    if (itemNr) {
      newState.search = itemNr;
      haveParam = true;
    }
    if (from && to) {
      newState.fromDate = moment(from);
      newState.toDate = moment(to);
      haveParam = true;
    }
    if (haveParam) {
      newState.change = true;
      this.setPageUrl();
      this.setState(newState);
    }
  };

  setPageUrl = () => {
    this.props.history.replace(`/${Helper.getLocale()}/sales`);
  };

  render() {
    const {
      browser,
      user,
      seller,
      isLoading,
      searchResult,
      isListing,
      isSessionLoading,
      sales,
      match,
      isCreating,
      disputes,
      disputeNr,
      history,
      disputeReasons
    } = this.props;

    const { ticketNr, key } = match.params;
    let title = "menu.disputes";
    const { search, page } = this.state;

    let searchLabel = "disputes.search-placeholder";

    const minimumDate = moment(this.state.fromDate || "");
    const maximumDate = moment(this.state.toDate || "");
    const minimumPaidAtDate = moment().subtract(1, "year");
    const maxDate = moment();

    const pageCount =
      sales && sales.items && sales.items.length < this.state.limits
        ? this.state.page
        : 100;

    const pageOptions = [
      {
        value: 40,
        key: 40,
        label: I18n.getText("stock-requests.per-page", { count: 40 })
      },
      {
        value: 80,
        key: 80,
        label: I18n.getText("stock-requests.per-page", { count: 80 })
      },
      {
        value: 120,
        key: 120,
        label: I18n.getText("stock-requests.per-page", { count: 120 })
      }
    ];
    return (
      <Layout
        currentIndex={18}
        title={title}
        search={this.state.search}
        searchLabel={!ticketNr && key !== "create" ? searchLabel : ""}
        onSearch={!ticketNr && key !== "create" ? this.onSearch : ""}
      >
        {isSessionLoading || isLoading ? (
          <Loader />
        ) : user && seller ? (
          seller.is_beta ? (
            <div className={styles.mainCtr}>
              {key === "create" ? (
                <CreateDisputes
                  searchDisputeAsnRtv={this.searchDisputeAsnRtv}
                  listDisputeReasons={this.listDisputeReasons}
                  searchResult={searchResult && searchResult.documents}
                  disputeReasons={disputeReasons && disputeReasons.reasons}
                  isListing={isListing}
                  isCreating={isCreating}
                  createDispute={this.createDispute}
                  disputeNr={disputeNr}
                  history={history}
                />
              ) : ticketNr ? (
                <div>
                  <DisputeDetails
                    data={
                      disputes &&
                      disputes.disputes &&
                      !_.isEmpty(disputes.disputes) &&
                      disputes.disputes[0]
                    }
                  />
                </div>
              ) : (
                <div>
                  <div className={`${styles.flexer} ${styles.tabView}`}>
                    <div className={styles.filterCtr}>
                      <div className={styles.eachFilter}>
                        <LocaleLink to={`/disputes/create`}>
                          <Button>
                            {I18n.getText("disputes.create-dispute")}
                          </Button>
                        </LocaleLink>
                      </div>
                    </div>
                  </div>
                  {disputes &&
                  disputes.disputes &&
                  !_.isEmpty(disputes.disputes) ? (
                    <DisputesTable
                      data={disputes && disputes.disputes}
                      browser={browser}
                      seller={seller}
                      searchString={search}
                    />
                  ) : (
                    <EmptyResults
                      heading={I18n.getText("transfers.nothing-to-show")}
                    />
                  )}
                  {disputes &&
                  disputes.no_of_pages &&
                  disputes.no_of_pages > 1 ? (
                    <div className={styles.paginationWrapper}>
                      <Pagination
                        pageCount={Number(disputes.no_of_pages)}
                        currentPage={page}
                        onPageChange={this.onPageChange}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          ) : (
            this.props.history.push(`/${Helper.getLang()}/`)
          )
        ) : (
          <EmptyResults heading={I18n.getText("transfers.nothing-to-show")} />
        )}
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    isLoading: state.disputes.isLoading,
    browser: state.browser,
    isListing: state.disputes.isListing,
    isCreating: state.disputes.isCreating,
    searchResult: state.disputes.searchResult,
    disputeReasons: state.disputes.disputeReasons,
    disputes: state.disputes.disputes,
    disputeNr: state.disputes.disputeNr
  };
};

export default connect(mapStateToProps)(StockRequest);



// WEBPACK FOOTER //
// ./src/containers/disputes/Disputes.js